module.exports = __webpack_public_path__ + "img/work.e1c7a5c8.svg";